import React from 'react';
import {Link} from 'react-router-dom';
const BotFooter =() => {

    return(

        <footer className="main-footer" style={{'margin':0,'position': 'fixed','bottom': '0','width': '100%', 'padding': '1%', 'fontSize': 'x-small'}}>
            <strong>
                <div style={{"float": "left"}}>
                    <Link  to="privacy-policies" target="_blank" rel="noopener noreferrer" >Privacy and Cookies Statement</Link>|<Link to="term-conditions" target="_blank" >Terms and Conditions</Link>|<a href="https://www.facebook.com/SohojMalaysia/" target="_blank" >Join Facebook</a>
                </div>

            </strong>

            Copyright (c) 2018 Red Grapes Sdn Bhd
            {/*<div className="float-right d-none d-sm-inline-block">
                <b>Version</b> 1.0.0.1-beta
            </div>*/}
        </footer>

    );

};

export default BotFooter;